import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import CloseButton from '../../../../components/CloseButton'

import './style.scss'

export default class Header extends Component {
    static propTypes = {
        icon: PropTypes.string,
        onClose: PropTypes.func,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    }

    static defaultProps = {
        icon: '',
        onClose: PropTypes.func,
    }

    render() {
        const { icon, onClose, text } = this.props

        return (
            <div className={'dialog-header'}>
                <div className={cx('icon', icon && icon)} />
                <div className={'title'}>{text}</div>
                <div className={'close'}>
                    <CloseButton onClick={onClose} size={20} />
                </div>
            </div>
        )
    }
}
